import { HostingAccountFormValidationSchema } from '../../../hostings.interfaces';

export const hostingAccountFormValidationSchema: HostingAccountFormValidationSchema = {
  login: [
    { required: true, message: 'Введіть логін' },
    { type: 'string', message: 'Логін має бути строкою' },
    { min: 1, max: 255, message: 'логін має бути довжиною не менше 1 символа та не більше 255' }
  ],
  password: [
    { required: true, message: 'Введіть пароль' },
    { type: 'string', message: 'Пароль має бути строкою' },
    { min: 1, max: 255, message: 'Пароль має бути довжиною не менше 1 символа та не більше 255' }
  ]
};
